/**
 * Country Overlay logic
 * Gestisce l'apertura/chiusura dell'overlay per la selezione di lingua e paese
 */

class CountryOverlay {
  constructor() {
    this.overlay = document.getElementById('country-overlay');
    if (!this.overlay) return;

    this.closeButton = this.overlay.querySelector('[data-country-overlay="close"]');
    this.backdrop = document.getElementById('backdrop-darker');

    this.init();
  }

  init() {
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeOverlay());
    }

    // Backdrop click
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.closeOverlay());
    }

    // Listener per aprire l'overlay
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-country-overlay-trigger]')) {
        e.preventDefault();
        this.openOverlay();
      }
    });
  }

  openOverlay() {
    this.overlay.classList.add('active');
    if (this.backdrop) {
      this.backdrop.classList.add('active');
      this.backdrop.style.zIndex = '55';
      document.body.style.overflow = 'hidden';
    }
  }

  closeOverlay() {
    this.overlay.classList.remove('active');
    if (this.backdrop) {
      this.backdrop.classList.remove('active');
      document.body.style.overflow = '';
      this.backdrop.style.zIndex = '';
    }
  }
}

new CountryOverlay();
